import Vue from 'vue';

// 导出一个Vue对象
// 注意：这是一个新的对象，与main.js里边的没有关系
export default new Vue;